import { useContext, useEffect, useMemo, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { QuizQuestionContext, SCREEN_QUIZ_QUESTION } from 'src/pages/quiz/contextAPI'
import { useNewLocation } from '../NewLocation/NewLocation.hook'
import moment from 'moment'
import {
  PATH_API,
  PATH_URL,
  REDIRECT_PATH,
  // redirect
} from 'src/helpers/path'
import { isDateFirstEntry, pushQuizStep } from 'src/helpers/quizEntry'
import { EVENT_QUIZ } from 'src/pages/quiz/contextAPI'
import { postHttp } from 'src/api'
import { EVENT_LOCATION_TYPE } from 'src/types'
import { useAvailabilityRequiredFields } from './RequiredFields'

export const useAvailability = () => {
  const history = useHistory()
  const { search } = useLocation()
  const location = useNewLocation()
  const { data, setQuizScreen, recordResponse } = useContext(QuizQuestionContext)
  const [selectedDate, setSelectedDate] = useState<Date | undefined>(undefined)
  const { handleGGPlaceSelected, handleChange, locationSelected, hasValue: locationHasValue, locationText } = location
  const [loading, setLoading] = useState(false)
  const [serviceable, setServiceable] = useState(true)
  const [unserviceableReason, setUnserviceableReason] = useState()
  const { locationError, requiredHint, handleLocationBlur } = useAvailabilityRequiredFields(
    selectedDate,
    locationHasValue
  )

  const handleNext = async () => {
    setLoading(true)
    try {
      const currentLocalStorage = JSON.parse(localStorage.getItem('tempPoppySessionData') || '{}')
      let currentQuizResponse = currentLocalStorage.quizResponses
      if (currentQuizResponse && currentQuizResponse.length > 0) {
        const eventDateKeyIndex = currentQuizResponse.findIndex(
          (e: { key: string; values: string[] | string }) => e.key === 'EVENT_DATE'
        )
        if (eventDateKeyIndex > -1) {
          currentQuizResponse[eventDateKeyIndex].values = moment(selectedDate).format('YYYY-MM-DD')
        } else {
          currentLocalStorage.push({
            key: 'EVENT_DATE',
            values: moment(selectedDate).format('YYYY-MM-DD'),
          })
        }
      } else {
        currentQuizResponse = [{ key: 'EVENT_DATE', values: moment(selectedDate).format('YYYY-MM-DD') }]
      }
      const result = await postHttp(PATH_API.checkAvailability(), {
        eventDateValue: moment(selectedDate).format('YYYY-MM-DD'),
        placeId: locationSelected.find((e) => e.type === EVENT_LOCATION_TYPE.CEREMONY)?.placeId,
        locationText,
      })
      if (result.data && result.data.serviceable === false) {
        setLoading(false)
        setServiceable(false)
        setUnserviceableReason(result.data.unserviceableReason)
        // redirect is here 0830
      } else {
        const totalWeddingNumber = parseInt(result.data?.totalWeddings) || 0
        const venueName = result.data?.venueName || ''
        localStorage.setItem(
          'tempPoppySessionData',
          JSON.stringify({
            ...currentLocalStorage,
            eventVenues: locationSelected,
            quizResponses: currentQuizResponse,
            totalWeddingNumber,
            venueName,
            isTier1LeadTimeAvailable: result.data?.isTier1LeadTimeAvailable,
          })
        )
        setLoading(false)
        if (isDateFirstEntry(search)) {
          pushQuizStep(history, PATH_URL.NEW_COLOR_PALETTE_PAGE, search)
          setQuizScreen(SCREEN_QUIZ_QUESTION.NEW_COLOR_PALETTE_PAGE)
        } else {
          history.push({ pathname: PATH_URL.YOUR_DETAILS })
          setQuizScreen(SCREEN_QUIZ_QUESTION.YOUR_DETAILS)
        }
      }
    } catch (error) {
      setLoading(false)
    }
  }

  const handleBack = () => {
    if (isDateFirstEntry(search)) {
      if (window.history.length > 1) {
        history.goBack()
      } else {
        localStorage.setItem('tempPoppySessionData', '{}')
        window.location.href = REDIRECT_PATH.HOME
      }
      return
    }
    history.goBack()
    setQuizScreen(SCREEN_QUIZ_QUESTION.NEW_COLOR_PALETTE_PAGE)
  }

  useEffect(() => {
    const currentTempData = JSON.parse(localStorage.getItem('tempPoppySessionData') || '{}')
    const currentDateData = currentTempData?.quizResponses?.find(
      (e: { key: string; values: string[] | string }) => e.key === EVENT_QUIZ.EVENT_DATE
    )
    if (currentDateData) {
      setSelectedDate(new Date(currentDateData.values))
    }
  }, [])

  const nextDisabled = useMemo(() => {
    return !selectedDate || !locationHasValue
  }, [selectedDate, locationHasValue])

  return {
    data,
    nextDisabled,
    locationError,
    requiredHint,
    handleLocationBlur,
    loading,
    handleBack,
    handleNext,
    recordResponse,
    selectedDate,
    location,
    setSelectedDate,
    handleGGPlaceSelected,
    handleChange,
    locationSelected,
    locationHasValue,
    serviceable,
    setServiceable,
    setUnserviceableReason,
    unserviceableReason,
  }
}
